<template>
    <el-popover 
        width="600"
        placement="right-start"
        trigger="hover"
        @show="onPopoverShow"
        :open-delay="200">
        <!-- 直接展示部分 -->
        <div
            style="display:inline-block;"
            slot="reference">

            <!-- 详情页 -->
            <span
                v-if="'detail'==mode && !!userEntity"
                :class="{'van-ellipsis' : true,
                    SystemUser : 'SystemUser' == userEntity.type,
                    TjkUser : 'TjkUser' == userEntity.type,
                    TicketTrigger : 'TicketTrigger' == userEntity.type
                }"
                style="cursor:pointer;">{{userEntity | ticketUserLabel}}</span>

            <!-- 其他页 -->
            <span
                v-else-if="!!userEntity"
                :class="{'van-ellipsis' : true,
                    SystemUser : 'SystemUser' == userEntity.type,
                    TjkUser : 'TjkUser' == userEntity.type,
                    TicketTrigger : 'TicketTrigger' == userEntity.type
                }"
                style="cursor:pointer;">{{userEntity | ticketUserLabel_2}}</span>
        </div>

        <!-- 浮窗部分 -->
        <div>
            <div>
                <span style="font-size:20px;">用户信息</span>

                <a style="float:right;padding-right:5px;"
                    title="个人信息页面"
                    target="_blank"
                    :href="'/ticket-vue/u?id=' + userEntity.id">主页</a>

                <a v-if="'TjkUser' == userEntity.type" style="float:right;padding-right:5px;"
                    title="跳转到 客服资料 页"
                    target="_blank"
                    :href="'/tjkInfoManage/serviceInformation?customerId=' + userEntity.id">客服资料</a>

                <a v-if="'TjkUser' == userEntity.type" style="float:right;padding-right:5px;"
                    title="跳转到 基础报酬 页"
                    target="_blank"
                    :href="'/system/action/salary/getSalaryDetailList?adminValue=flag&url=$url&groupId=' + userEntity.id">基础报酬</a>
            </div>

            <div class="item_1">
                <span class="_left_1">ID:</span>
                <span>{{userEntity.id}}</span>
            </div>
            <div class="item_1">
                <span class="_left_1">昵称:</span>
                <span>{{userEntity.name}}</span>
            </div>
            <div  class="item_1">
                <span class="_left_1">类型:</span>
                <span>{{userEntity.type|userTypeLabel}}</span>
            </div>
            <div class="item_1">
                <span class="_left_1">用户名:</span>
                <span>{{userEntity.loginName}}</span>
            </div>
            <div class="item_1">
                <span class="_left_1">电话:</span>
                <span>{{userEntity.phone}}</span>
            </div>
            <div class="item_1">
                <span class="_left_1">邮箱:</span>
                <span>{{userEntity.mail}}</span>
            </div>
            <div style="margin-top:100px;">
                <h4>{{eventListTitle}}</h4>
            </div>
            <div
                :title="each.ticketTitle + ' ' + each.operateContent + ' ' + (each.assignUserId||'')"
                style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;"
                v-for="each in ticketEventList"
                :key="each.id">
                <span>{{each.createdAt|ticketTime}}</span>
                <span style="color:DarkGray;">在工单</span>
                <a :href="'/ticket/t/' + each.orderId" style="color: #409eff;">{{each.ticketTitle}}</a>
                <span>{{each.operateContent}}</span>

                <span v-if="each.assignUserId">
                    给
                    <TicketUser :userId="each.assignUserId"/>
                </span>
            </div>
        </div>
    </el-popover>
</template>

<script>
export default {
  name: "TicketUser",

  props: ['user', 'ticketNo', 'userId'],

  data() {
    return {
        eventListTitle : '动态(加载中)',
        ticketEventList : [],
        mode : "view",
        userEntity : {}
    };
  },

  watch : {
    user() {
        this.onUserChange();
    },

    userId() {
        this.onUserChange();
    }
  },

  mounted() {
    if ( "/ticket-vue/ticket/detail" == this.$route.path // 
        || ( !!this.$route.query.ticketType && "9" == this.$route.query.ticketType ) ) {
        this.mode = "detail";
    }

    this.onUserChange();
  },

  methods : {
    onUserChange() {
        var _this = this;

        // 传了用户id
        if ( !!_this.user ) {
            _this.userEntity = _this.user || {};
            return;
        }

        // 传了用户 id
        if ( !!_this.userId ) {
            _this.userEntity = {};
            _this.loadUserByIdCached();
            return;
        } else {
            _this.userEntity = { name : ' ' }; // 名字为空串
        }
    },

    loadUserByIdCached() {
        var _this = this;

        if ( !window.TicketUserList ) {
            window.TicketUserList = [];
        }

        window.TicketUserList.push(this);

        clearTimeout(window.TicketUserTimeoutId);
        window.TicketUserTimeoutId = setTimeout(this._doLoad, 800);
    },

    _doLoad() {
        var _this = this;

        if ( !window.TicketUserList || window.TicketUserList.length < 1 ) {
            // console.log("#155 window.TicketUserList=", window.TicketUserList);

            clearTimeout(window.TicketUserTimeoutId);
            window.TicketUserTimeoutId = setTimeout(this._doLoad, 1500); // 太快了？
            return;
        }

        sdk.TicketUserApi().listByIdsCached({
          ids : window.TicketUserList.map(e => e.userId)
        }).then(res => {
          for ( var i=0; i < window.TicketUserList.length; i++ ) {
            var _each = window.TicketUserList[i];
            var _ticketUser = _this.findUserById(res, _each.userId);
            _each.userEntity = _ticketUser || { name: _each.userId };
          }

          // 清理
          window.TicketUserTimeoutId = null;
          window.TicketUserList = null;
        });
    },

    findUserById(list, id) {
        for ( var i=0; i < list.length; i++ ) {
          if(list[i].id + "" == id + "" ) {
            return list[i];
          }
        }

        return null;
    },

    onPopoverShow() {
        if ( !this.userId && ( !this.user || !this.user.id ) ) {
            console.log('#120 this.user=', this.user, ', this=', this);
            return;
        }

        window._doNotShowLoading = true; // 禁止 loading 干扰 hover

        var _this = this;
        sdk.TicketEventApi().listByUserIdAndOrganization({
            userId : _this.userId || _this.user.id,
            page : { pageSize : 9, orderBy : '`flow_id` DESC' }
        }).then(res => {
            _this.ticketEventList = res.list;

            if( !res.list || res.list.length < 1 ) {
                _this.eventListTitle = "";
            } else {
                _this.eventListTitle = "动态";
            }

            window._doNotShowLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.SystemUser {
    color: #CC9966
}

.TjkUser {
    color: #CCCC99
}

.TicketTrigger {
    color: #336699
}

.item_1 {
    width : 50%;
    float: left;
}

._left_1 {
    padding-top: 5px;
    display : inline-block;
    width: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketUser.vue